import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const PAGE_SIZE = 10;

export default function LatestList() {
  const sorted = useMemo(() => [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)), []);
  const [visible, setVisible] = useState(PAGE_SIZE);
  const list = sorted.slice(0, visible);
  const hasMore = visible < sorted.length;

  return (
    <section className="bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-8">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Latest</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新内容</h2>
          </div>
          <p className="text-sm text-foreground-500">
            共 {sorted.length} 篇 · 已显示 {list.length} 篇
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {list.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group grid grid-cols-1 items-center gap-4 rounded-lg border border-foreground-200/70 bg-background-50 p-3 sm:grid-cols-[160px_1fr_auto] md:p-4"
            >
              <div className="aspect-[4/3] w-full overflow-hidden rounded-md bg-background-200 sm:aspect-[4/3] sm:h-28 sm:w-40">
                <img
                  src={item.cover}
                  alt={`${item.title} 最新搭配`}
                  title={`${item.title} - 黑丝时尚搭配`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-secondary-900">{item.tags[0]}</span>
                  <span>{item.date}</span>
                  <span className="hidden sm:inline">· {item.readTime}</span>
                </div>
                <h3 className="mt-2 line-clamp-2 font-heading text-lg font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{item.excerpt}</p>
              </div>
              <div className="hidden shrink-0 items-center gap-1 text-sm text-foreground-500 md:flex">
                <i className="ri-eye-line" /> {item.popularity}
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          {hasMore ? (
            <button
              type="button"
              onClick={() => setVisible((v) => v + PAGE_SIZE)}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              加载更多
              <i className="ri-arrow-down-line" />
            </button>
          ) : (
            <span className="rounded-full border border-foreground-200 px-6 py-3 text-sm text-foreground-500">
              已加载全部内容
            </span>
          )}
        </div>
      </div>
    </section>
  );
}